import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input, OnDestroy,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {MobileViewService} from 'gelios-ng-admin-components';
import {ActivatedRoute, Router} from '@angular/router';
import {MapWidgetService} from './map-widget.service';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';

interface Widget {
  width: number;
  hiddenWidth: number;
  height: number;
  show: boolean;
  name: string;
}

@Component({
  selector: 'app-map-widget',
  templateUrl: 'map-widget.component.html'
})
export class MapWidgetComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.widget') classWidget = true;
  @HostBinding('class.expanded') showContent = true;
  @HostBinding('class.transition-enabled') transitionEnabled = false;
  @HostBinding('style') style: SafeStyle;
  @ViewChild('contentWrapper') contentWrapper: ElementRef;
  subscriptions: Subscription[] = [];
  @Input() resizeEdges: {
    bottom: boolean,
    right: boolean,
    top: boolean,
    left: boolean
  };

  @Input() title = '';
  @Input() allowHide = true;
  @Input() allowClose = false;
  @Input() widthWhenContentHidden = 400;
  @Input() widthWhenContentShown = 400;
  @Input() hideTitle = false;
  @Input() showFooter = false;
  @Input() height = null;
  @Input() showContentOnStart = true;
  @Input() widgetName = null;

  @Output() closeWidget = new EventEmitter();

  @Input() contentMinHeight = 300;
  private storedHeight: number;
  private storedWidth: number;


  @HostListener('resizeEnd', ['$event']) onResizeEnd(event) {
    this.style = this.sanitizer.bypassSecurityTrustStyle(
      `width: ${event.rectangle.width}px; height: ${event.rectangle.height}px`
    );

    if (this.mobileView.mobileViewEnabled === false && this.widgetName) {
      const wid: Widget = {
        name: this.widgetName,
        show: this.showContent,
        width: event.rectangle.width,
        height: event.rectangle.height,
        hiddenWidth: this.widthWhenContentHidden
      };
      this.widgetService.saveWidget(wid);
      this.widgetService.contentWrapperHeight.next({
        name: this.widgetName,
        height: event.rectangle.height
      });
    }
  }

  get headerHiddenHeight() {
    return this.router.url.startsWith('/dashboard/monitoring') && this.mobileView.mobileViewEnabled ? 0 : 32;
  }

  get showHeader() {
    return !(this.router.url.startsWith('/dashboard/monitoring') && !this.allowClose && this.mobileView.mobileViewEnabled);
  }

  onToggleContent() {
    this.showContent = !this.showContent;
    if (this.showContent) {
      this.style = this.sanitizer.bypassSecurityTrustStyle(
        `width: ${this.storedWidth}px; height: ${this.storedHeight}px`
      );
    } else {
      this.storedWidth = this.nativeElement.nativeElement.offsetWidth;
      this.storedHeight = this.nativeElement.nativeElement.offsetHeight;
      this.style = this.sanitizer.bypassSecurityTrustStyle(
        `width: ${this.widthWhenContentHidden}px; height: ${this.headerHiddenHeight}px`
      );
    }
    if (this.mobileView.mobileViewEnabled === false && this.widgetName) {
      const wid: Widget = {
        name: this.widgetName,
        show: this.showContent,
        width: this.storedWidth,
        height: this.storedHeight,
        hiddenWidth: this.widthWhenContentHidden
      };
      this.widgetService.saveWidget(wid);
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s ? s.unsubscribe : '');
  }

  onCloseWidget(event) {
    this.closeWidget.emit(event);
  }

  constructor(
    private nativeElement: ElementRef,
    private sanitizer: DomSanitizer,
    private mobileView: MobileViewService,
    private router: Router,
    private widgetService: MapWidgetService,
  ) {

  }

  setWidthWhenContentShown(): void {
    this.style = this.sanitizer.bypassSecurityTrustStyle(
      `width: ${this.widthWhenContentShown}px;`
    );
  }

  ngOnInit(): void {
    if (this.mobileView.mobileViewEnabled === false && this.widgetName) {
      const widgetArray = this.widgetService.getWidgetArray();
      if (widgetArray !== null) {
        const widget = this.widgetService.getWidgetByName(this.widgetName);
        if (widget !== undefined) {
          this.showContent = widget.show;
          this.storedWidth = widget.width;
          this.storedHeight = widget.height;
          if (widget.show) {
            this.style = this.sanitizer.bypassSecurityTrustStyle(
              `width: ${widget.width}px; height: ${widget.height}px`
            );
          } else {
            this.style = this.sanitizer.bypassSecurityTrustStyle(
              `width: ${widget.hiddenWidth}px; height: ${this.headerHiddenHeight}px`
            );
          }
        } else {
          this.setWidthWhenContentShown();
        }
      } else {
        this.setWidthWhenContentShown();
      }
    } else {
      this.setWidthWhenContentShown();
    }
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.widgetService.widgetHeight
        .pipe(
          filter(v => v !== null),
        )
        .subscribe(v => {
          if (v.name === this.widgetName) {
            const widget = this.widgetService.getWidgetByName(this.widgetName);
            if (widget !== null) {
              this.style = this.sanitizer.bypassSecurityTrustStyle(
                `width: ${widget.width}px; height: ${v.height}px`
              );
            }
          }
        })
    );
    if (!this.showContentOnStart) {
      if (this.storedHeight === undefined) {
        this.storedHeight = this.contentMinHeight;
      }
      this.onToggleContent();
    }
  }
}
